import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dialog } from 'primereact/dialog';

import { Button } from "../../helpers";
import Menu from '../../helpers/Menu'

import Loading from "../../common/Loading"
import ButtonGroup from '../../common/ButtonGroup';

import "./index.css"

import ProcessRejectedStock from './Components/ProcessRejectedStock'
import ProcesCreditNote from './Components/ProcessCreditNote';
import AddStockAdjustmentNew from './Components/StockAdjustment/StockAdjustment';
import CreateSellerDebitNote from './Components/createdSellerDebitNote';
import ReleaseClientHold from './Components/ReleaseClientHold';
import StockTransfer from './Components/StockTransfer';
import ScrapToSmart from './Components/ScrapToSmart';

import { fetchCompanyWarehouses, fetchGSTRates, fetchMaterialBrands } from '../../services/redux/reducers/commonThunk'



const StockAdjustment = () => {
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)

    const [visibleNewAddStockAdjustment, setNewVisibleAddStockAdjustment] = useState(false)
    const [visibleProcessRejectedStock, setVisibleProcessRejectedStock] = useState(false)
    const [visibleProcessCreditNote, setVisibleProcessCreditNote] = useState(false)
    const [visibleCreateSellerDebitNote, setVisibleCreateSellerDebitNote] = useState(false)
    const [visibleReleaseClientHold, setVisibleReleaseClientHold] = useState(false)
    const [visibleStockTransfer, setVisibleStockTransfer] = useState(false)
    const [visibleScrapToSmart, setVisibleScrapToSmart] = useState(false)

    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const companyWarehouses = useSelector(state => state.common.companyWarehouses)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    let GSTRates = useSelector((state) => state.common.GSTRates)
    
    GSTRates = GSTRates.map(eachGSTRate =>{
        return {...eachGSTRate, GSTRateStr: eachGSTRate.GSTRate + ''}
    })

    const actionMenu = useRef(null)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchCompanyWarehouses())
        dispatch(fetchGSTRates())
        dispatch(fetchMaterialBrands())
    }, [])

    const actionMenuItems = [
        // {
        //     label: 'Add Stock Adjustment',
        //     icon: '',
        //     command: () => {
        //         setVisibleAddStockAdjustment(true)
        //     },
        //     permissions: [33]
        // },
        {
            label: 'Add Stock Adjustment',
            icon: '',
            command: () => {
                setNewVisibleAddStockAdjustment(true)
            },
            permissions: [152]
        },
        {
            label: 'Process Rejected Stock',
            icon: '',
            command: () => {
                setVisibleProcessRejectedStock(true)
            },
            permissions: [153]
        },
        {
            label: 'Release Client Hold',
            icon: '',
            command: () => {
                setVisibleReleaseClientHold(true)
            },
            permissions: [160]
        },
        {
            label: 'Create Seller Debit Note',
            icon: '',
            command: () => {
                setVisibleCreateSellerDebitNote(true)
            },
            permissions: [154]
        },
        {
            label: 'Stock Transfer',
            icon: '',
            command: () => {
                setVisibleStockTransfer(true)
            },
            permissions: [153]
        },
        {
            label: 'Scrap To Smart',
            icon: '',
            command: () => {
                setVisibleScrapToSmart(true)
            },
            permissions: [153]
        }
    ]
    
    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        }
    ]

    return (
        <div className=''>
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">STOCK ADJUSTMENTS</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    {/* <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className="">
                <AddStockAdjustmentNew
                    companyWarehouses={companyWarehouses}
                    GSTRates={GSTRates}
                    visible={visibleNewAddStockAdjustment}
                    setNewVisibleAddStockAdjustment={setNewVisibleAddStockAdjustment}
                />
                <Dialog header="Process Rejected Stock" className="process-rejected-stock" visible={visibleProcessRejectedStock} style={{ width: '80vw', minHeight: "60%" }} onHide={() => setVisibleProcessRejectedStock(false)} >
                    <ProcessRejectedStock companyWarehouses={companyWarehouses} setVisibleProcessRejectedStock={setVisibleProcessRejectedStock} />
                </Dialog>
                <ReleaseClientHold 
                    companyWarehouses={companyWarehouses}
                    visible={visibleReleaseClientHold}
                    setVisibleReleaseClientHold={setVisibleReleaseClientHold}
                    materialBrands={materialBrands}
                />
                <CreateSellerDebitNote
                    companyWarehouses={companyWarehouses}
                    visible={visibleCreateSellerDebitNote}
                    setVisibleCreateSellerDebitNote={setVisibleCreateSellerDebitNote}
                    pmCompanyDetails={pmCompanyDetails}
                />
                <StockTransfer
                    companyWarehouses={companyWarehouses}
                    visible={visibleStockTransfer}
                    setVisibleStockTransfer={setVisibleStockTransfer}
                />
                <ScrapToSmart
                    companyWarehouses={companyWarehouses}
                    visible={visibleScrapToSmart}
                    setVisibleScrapToSmart={setVisibleScrapToSmart}
                    GSTRates={GSTRates}
                />
                <Dialog header="Process Credit Note" className="process-credit-note" visible={visibleProcessCreditNote} style={{ width: '60vw', minHeight: "60%" }} onHide={() => setVisibleProcessCreditNote(false)} >
                    <ProcesCreditNote />
                </Dialog>
            </div>
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default StockAdjustment